import script from "./dupliPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./dupliPopUp.vue?vue&type=script&setup=true&lang=js"

import "./dupliPopUp.vue?vue&type=style&index=0&id=1cbcfa94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cbcfa94"]])

export default __exports__